import { subscriptionAccess } from "./en.subscription-access";
import { subscriptionCancel } from "./en.subscription-cancel";
import { subscriptionDetails } from "./en.subscription-details";
import { subscriptionInvoices } from "./en.subscription-invoices";
import { subscriptionManage } from "./en.subscription-manage";
import { subscriptionRenew } from "./en.subscription-renew";
import { subscriptionSettings } from "./en.subscription-settings";

export const subscriptionManagement = {
  ...subscriptionAccess,
  ...subscriptionCancel,
  ...subscriptionDetails,
  ...subscriptionInvoices,
  ...subscriptionManage,
  ...subscriptionRenew,
  ...subscriptionSettings,
};
